(ns dashboard.views.questionnaire.question-lab.subs
  (:require [re-frame.core :as rf]
            [dashboard.entity.analysis.db :as analysis.db]
            [dashboard.services.questionnaires :as questionnaires]
            [io.repliance.util.tree :as tree]))

(rf/reg-sub
 ::question-lab
 (fn [db]
   (:question-lab db)))

(rf/reg-sub
 ::edit-answer-state
 :<- [::question-lab]
 (fn [question-lab [_ questionnaire-id]]
   (get-in question-lab [questionnaire-id :edit-answer-state])))

(rf/reg-sub
 ::editor-dirty?
 (fn [[_ questionnaire-id]]
   (rf/subscribe [::edit-answer-state questionnaire-id]))
 (fn [edit-state]
   (:dirty? edit-state)))

(rf/reg-sub
 ::editor-field
 (fn [[_ questionnaire-id _]]
   (rf/subscribe [::edit-answer-state questionnaire-id]))
 (fn [edit-answer-state [_ _ field]]
   (get edit-answer-state field)))

(rf/reg-sub
 ::question-index
 :<- [::question-lab]
 (fn [question-lab [_ questionnaire-id]]
   (get-in question-lab [questionnaire-id :question-index] 0)))

(rf/reg-sub
 ::question-ids
 :<- [::question-lab]
 (fn [question-lab [_ questionnaire-id]]
   (get-in question-lab [questionnaire-id :question-ids])))

(rf/reg-sub
 ::current-question
 (fn [[_ questionnaire-id]]
   [(rf/subscribe [::questionnaires/questions questionnaire-id])
    (rf/subscribe [::question-ids questionnaire-id])
    (rf/subscribe [::question-index questionnaire-id])])
 (fn [[questions question-ids question-index]]
   (->> questions
        (filter #(= (:id %) (nth question-ids question-index)))
        first)))

(rf/reg-sub
 ::questions-by-id
 (fn [db [_ questionnaire-id]]
   (->> (get-in db [:questionnaires questionnaire-id :questions :data])
        (group-by :id))))

;; Creates a depth-first serialization, via tree-seq, of latest structured analyses, that have applied analyses that have links to the questions
(rf/reg-sub
 ::analyses-for-answer
 :<- [::analysis.db/structured-analyses-data]
 :<- [::analysis.db/applied-analyses-data]
 (fn [[structured-analyses-data applied-analyses-data] [_ analysis-pred]]
   (->> (tree/sort-hierarchical (map (comp first second) structured-analyses-data)
                                :construct-id
                                compare
                                :construct-id)
        (map (fn [structured-analysis]
               (assoc structured-analysis :applied-analyses
                      (map (fn [applied-analysis]
                             (assoc applied-analysis
                                    ;; Add the full structured analysis, that the applied analysis points to, to the applied analysis
                                    :structured-analysis (first (filter (fn [structured-analysis]
                                                                          (= (:structured-analysis-version-uuid applied-analysis) (:version-id structured-analysis)))
                                                                        (get structured-analyses-data (:construct-id applied-analysis))))))
                           (get applied-analyses-data (:construct-id structured-analysis))))))
        (filter (fn [{:keys [applied-analyses]}]
                  (seq (filter analysis-pred applied-analyses)))))))
